import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Box } from "@mui/material";
import { ArrowDropDown, HomeRounded, PowerSettingsNewRounded } from "@mui/icons-material";
import { useState, useEffect } from "react";
import "./Header.css";
import DropdownMenu from "./DropdownMenu";
import { useAuth0 } from "@auth0/auth0-react";
import { getLoggedInUserDetails, getRoleOfInternalUser } from "./constants/globalconstants";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultCareFacility, maskedAccountId } from "./Utils";
import LogoutModal from "./LogoutModal";
import { storeUserRole, updateCareFacility, updateCareFacilityList } from "../../action";
import axiosInstance from "./AxiosInterceptor";
import ErrorModal from "./ErrorModal";

const listingMenuItems = [
  {
    title: "Direct Deposit Listing",
    url: "/directDepositListing",
  },
  {
    title: "Resident Status Listing",
    url: "/residentListings",
  },
  {
    title: "Allowance Update Listing",
    url: "/allowanceListings",
  },
];

const userReportsMenuItems = [
  {
    title: "Care Facility Report",
    url: "/reports",
  },
  {
    title: "Enrollment Audit Logs",
    url: "/userEnrollmentReports",
  }
];

const adminReportMenuItems = [
  {
    title: "User Login Audit",
    url: "/admin/loginReport",
  },
  {
    title: "Care Facility Audit Logs",
    url: "/admin/careFacilityAuditReport",
  },
  {
    title: "Care Facility User Audit Logs",
    url: "/admin/careFacilityUserAuditReport",
  },
  {
    title: "Access Control Audit Logs",
    url: "/admin/aclAuditReport",
  },
  {
    title: "Billing Report",
    url: "/admin/billingReport"
  }
];


const jobsMenuItems = [
  {
    title: "ACH Files",
    url: "/admin/achFilesJob",
  }
];


const profileItems = [
  {
    name: "Company Name:  ",
    key: "careFacilityName",
    value: "",
  },
  {
    name: "Account No.  ",
    key: "accountNumber",
    value: "",
  },
  {
    name: "Address: ",
    key: "address",
    value: "",
  },
  {
    name: "Telephone: ",
    key: "phone",
    value: "",
  },
  {
    name: "Contact: ",
    key: "contactPerson",
    value: "",
  },
  {
    name: "Email: ",
    key: "email",
    value: "",
  },
];

function Header(props) {
  const { user, logout } = useAuth0();
  const [openListing, setOpenListing] = useState(false);
  const [openUserReportMenu, setOpenUserReportMenu] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAdmReportMenu, setOpenAdmReportMenu] = useState(false);
  const [openJobsMenu, setOpenJobsMenu] = useState(false);;
  const [loading, setloading] = useState(true); //true
  const [logoutFlag, setLogoutFlag] = useState(false);
  const [role, setRole] = useState("");
  const [errormodalopen, seterrormodalOpen]= useState(false);

  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  const dispatch = useDispatch();
  let isAdmin = false;
   if (user !== undefined) {
    isAdmin = user["usertype"] === "internal" ? true : false;
  }

  const storeuser = useSelector((state) => state.storeuser);
  const storetoken = useSelector((state) => state.storetoken);
  const userAccessRole = useSelector((state) => state.userAccessRole);
  const timeoutRef = useRef(null);

  React.useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

   useEffect(() =>{
       if(role === "" && storetoken !== "storeToken" 
        && storeuser && storeuser.email !== "email" && isAdmin){
          getUserRole();
       }
     },[storetoken]);
   
  
    const getUserRole = async() =>{
          try {          
            let response;
            const request = {
              userName: storeuser.email
            }
            response = await axiosInstance.post(`${getRoleOfInternalUser}`,JSON.stringify(request));
            if(response.data.isSuccess){
               const role = response.data.result && response.data.result.roleName;
               setRole(role);
               dispatch(storeUserRole(role));
               seterrormodalOpen(false);
            }
            else if(!response.data.isSuccess){
              seterrormodalOpen(true);
            }
        } catch (error) {
          console.log(error.message);
          seterrormodalOpen(true);
        }
      }

  useEffect(() => {
    if (
      storetoken !== "" && storetoken !== "storeToken" &&
      storeuser !== undefined && storeuser.email !== "email" && 
      storeuser.usertype != "internal" &&
      Object.keys(carefacilitydetails).length === 0
    ) {
    const timer = setTimeout(() => {
        fetchCareFacilityDetails();
    }, 2000);

    return () => clearTimeout(timer);
  } else {
    setloading(false);
  }
  }, [storetoken, storeuser]);

  const fetchCareFacilityDetails = async() => {
    const data = await axiosInstance.get(`${getLoggedInUserDetails}?userName=${storeuser.email}`);
    dispatch(updateCareFacilityList(data.data.result));
    const defaultData = getDefaultCareFacility(data.data.result);
    dispatch(updateCareFacility(defaultData));
    setloading(false);
  };

  useEffect(() => {
    if (carefacilitydetails) {
      updateUserProfile();
    }
  }, [carefacilitydetails]);

  const handleMouseLeave =() =>{
    timeoutRef.current = setTimeout(()=>{
      setOpenAdmReportMenu(false);
      setOpenJobsMenu(false);
      setOpenListing(false);
      setOpenUserReportMenu(false);
      setOpenProfile(false);
    },200);
  }

  const updateUserProfile = () => {
    profileItems.map((item) => {
      if (item.key === "accountNumber") {
        item.value = maskedAccountId(carefacilitydetails[item.key]);
      } else {
        item.value = carefacilitydetails[item.key];
      }
    });
  };

  const onClickLogout = () => {
    setLogoutFlag(true);
  };

  const LogoutModalClose = (_, reason) => {
    if (reason !== "backdropClick") {
      setLogoutFlag(false);
    }
  };

   const onConfirmLogout = () => {
    const clientId = window.REACT_APP_AUTH0_CLIENT_ID;
     logout({
      logoutParams: {  returnTo: window.location.origin,
      client_id: clientId,
      }
     });
     localStorage.clear();
     sessionStorage.clear();
     window.location.href = window.location.origin;
   };


  return (
    <div style={{ width: "100%" }}>
      <AppBar position="static" sx={{ backgroundColor: "#fff", width: "100%" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <img
            alt=""
            height="40px"
            style={{ margin: "20px" }}
            src="https://www.websterbank.com/wp-content/uploads/2021/08/Webster-Bank-lock-up-RBG-3-1.svg"
          />
          <Box
          sx={{
            flexDirection: "row",
            alignItems: "right",
            justifyContent: "right",
            columnGap: "0.4rem",
          }}
          >
          {props.isVisible && (
            <div
            onMouseLeave={() => {
             handleMouseLeave();
            }}>
              <div
                style={{
                  float: "right",
                  color: "black",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  alignContent: "right",
                }}
              >
                <div className="home-menu">
                  <Link to="/home">
                    <IconButton
                      title="Home"
                      sx={{ boxShadow: "none" }}
                      className="icon-btn"
                    >
                      <HomeRounded className="arrow-icon" />
                    </IconButton>
                  </Link>
                  {/* {"|"} */}
                 
                </div>
                <div className="pipeline-seperator"></div>
                
                {storeuser !== undefined && storeuser.usertype === "internal" ? (
                  <>
                        <div
                          className="reports-menu"
                          onMouseEnter={() => {
                            clearTimeout(timeoutRef.current);
                            setOpenAdmReportMenu(true);
                            setOpenJobsMenu(false);
                          }}
                        >
                          Reports
                          <IconButton
                            sx={{ boxShadow: "none" }}
                            className="icon-btn"
                          >
                            <ArrowDropDown className="arrow-icon" />
                          </IconButton>
                          {openAdmReportMenu && (
                            <div
                            onMouseLeave={() => {
                              setOpenAdmReportMenu(false);
                              handleMouseLeave();
                            }}>
                            <DropdownMenu
                              submenus={adminReportMenuItems}
                              isVisible={true}
                            />
                            </div>
                          )}                           
                        </div>

                        <div className="pipeline-seperator"></div> 

                        <div className="download">
                          {/* <Link href="#" underline="none" component="button" onClick={handleDownloadClick}>Download</Link> */}
                          <Link className="download-link" to="/admin/downloadListings">
                           Downloads
                          </Link>
                        </div>

                        <div className="pipeline-seperator"></div>

                        <div
                          className="jobs-menu"
                          onMouseEnter={() => {
                            clearTimeout(timeoutRef.current);
                            setOpenJobsMenu(true);
                            setOpenAdmReportMenu(false);
                          }}
                        >
                          Jobs
                          <IconButton
                            sx={{ boxShadow: "none" }}
                            className="icon-btn"
                          >
                            <ArrowDropDown className="arrow-icon" />
                          </IconButton>
                          {openJobsMenu && (
                            <div
                            onMouseLeave={() => {
                              setOpenJobsMenu(false);
                              handleMouseLeave();
                            }}>
                            <DropdownMenu
                              submenus={jobsMenuItems}
                              isVisible={true}
                            />
                            </div>
                          )}                           
                        </div>
                      {userAccessRole && userAccessRole === "Write" && role === "Write" ? 
                      <>
                        <div className="pipeline-seperator"></div>

                        <div className="acc-ctrl-menu">
                         <Link className="acl-link" to="/admin/acl">
                           ACL
                          </Link>
                        </div>
                        </>
                      : null}  
                      </>
                ) : (
                  ""
                )}
                
                {storeuser !== undefined && storeuser.usertype === "external" ? (
                  <>
                    {props.buttonsVisible && (
                      <>
                        <div
                          className="menu"
                           onMouseEnter={() => {
                            clearTimeout(timeoutRef.current);
                            setOpenProfile(false);
                            setOpenUserReportMenu(false);
                            setOpenListing(true);
                           }}
                        >
                          <span className="menu-text">Listing</span>
                          <IconButton
                            sx={{ boxShadow: "none" }}
                            className="icon-btn"
                          >
                             <ArrowDropDown className="arrow-icon"/>
                          </IconButton>
                          {openListing && (
                            <div
                            onMouseLeave={() => {
                              setOpenListing(false);
                              handleMouseLeave();
                            }}>
                            <DropdownMenu
                              submenus={listingMenuItems}
                              isVisible={true}
                            />
                            </div>
                          )}
                        </div>
                        
                        <div className="pipeline-seperator"></div>                    

                        {/* {<div className="reports-div"> 
                          <Link className="reports" to="/reports">
                           Reports
                          </Link>
                          <div className="long-pipeline"></div>
                        </div>} */}                        
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}

                {storeuser !== undefined && storeuser.usertype === "external" ? (
                  <>
                    {//props.buttonsVisible && 
                    (
                      <>
                        <div
                          className="user-reports-menu"
                          onMouseEnter={() => { 
                            clearTimeout(timeoutRef.current);                           
                            setOpenListing(false);
                            setOpenProfile(false);
                            setOpenUserReportMenu(true);
                          }}
                        >
                          Reports
                          <IconButton
                            sx={{ boxShadow: "none" }}
                            className="icon-btn"
                          >
                             <ArrowDropDown className="arrow-icon" />
                          </IconButton>
                          {openUserReportMenu && (
                            <div
                            onMouseLeave={() => {
                              setOpenUserReportMenu(false);
                              handleMouseLeave();
                            }}>
                            <DropdownMenu
                              submenus={userReportsMenuItems}
                              isVisible={true}
                            />
                            </div>
                          )}                    

                        </div>
                       
                        <div className="long-pipeline"></div>                    
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}

                {storeuser !== undefined && storeuser.usertype ==="internal" ?
                <div className="long-pipeline"></div> : ""}

                <div
                  className="profile-menu"
                  onMouseEnter={() => {
                    clearTimeout(timeoutRef.current);
                    setOpenUserReportMenu(false);
                    setOpenListing(false);
                    setOpenProfile(true);
                  }}
                >
                  Hello,
                  <span className={storeuser !== undefined && storeuser.usertype === "external"?"profile-user-header":"profile-admin-header"}>
                    {" "}
                    {storeuser != undefined
                      ? storeuser.nickname
                      : user?.nickname || ""}
                    !
                  </span>
                {storeuser != undefined && storeuser.usertype == "external" ? (
                    <>
                      {props.buttonsVisible && (
                        <IconButton
                          sx={{ boxShadow: "none" }}
                          className="icon-btn"
                        >
                          <ArrowDropDown className="arrow-icon" />
                        </IconButton>
                      )}
                      {openProfile && (
                        <div
                        onMouseLeave={() => {
                          setOpenProfile(false);
                          handleMouseLeave();
                        }}>
                        <DropdownMenu
                          submenus={profileItems}
                          isVisible={props.buttonsVisible}
                          isProfile={true}
                        />
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="home-menu">
                  <IconButton
                    sx={{ boxShadow: "none" }}
                    className="icon-btn"
                    title="Log Out"
                    onClick={onClickLogout}
                  >
                    <PowerSettingsNewRounded className="logout-button" />
                  </IconButton>
                </div>
              </div>
            </div>
          )}
          
          
          </Box>
        </Toolbar>
      </AppBar>
      {logoutFlag && (
        <LogoutModal
          open={true}
          onClose={LogoutModalClose}
          onConfirmLogout={onConfirmLogout}
        />
      )}
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}

export default Header;
